<template>
    <div class="dropdown" v-if="options">

        <label :id="labelId" :for="inputId" class="form-label">{{labelText}}</label>
      <!-- Dropdown Input -->
      <input class="dropdown-input"
        :id="inputId"
        :name="name"
        @focus="showOptions()"
        @keyup="keyMonitor"
        v-model="searchFilter"
        :disabled="disabled"
        :placeholder="placeholder"
        @change="update" 
        :aria-labelledby="labelId"
        :aria-describedby="errorId"
        tabindex="0" v-click-outside="HandleClickOutside" ref="inputRef" />

    <i class="arrow down"></i>
  
      <!-- Dropdown Menu -->
      <div class="dropdown-content" v-show="optionsShown" ref="dropdownContent">

        <div
          class="dropdown-item"
          @mousedown="selectOption(option)"
          v-for="(option, index) in filteredOptions"
          :key="index">
            {{ option.value || option.key || '-' }}
        </div>
      </div>

        <div class="errorMessageForm" v-for="error of myErrors" :key="error.$uid">
            {{error.$message}}
        </div>

    </div>
  </template>
  
  <script>

  import vClickOutside from "click-outside-vue3";

    export default {
      name: 'DropdownInputSearchable',
      components:{
        vClickOutside
      },
      props: {
        name: {
          type: String,
          required: false,
          default: 'dropdown',
          note: 'Input name'
        },
        options: {
          type: Array,
          required: true,
          default: () => [],
          note: 'Options of dropdown. An array of options with id and name',
        },
        placeholder: {
          type: String,
          required: false,
          default: 'Please select an option',
          note: 'Placeholder of dropdown'
        },
        disabled: {
          type: Boolean,
          required: false,
          default: false,
          note: 'Disable the dropdown'
        },
        maxItem: {
          type: Number,
          required: false,
          default: 999,
          note: 'Max items showing'
        },
        myErrors:Array,
        objectKey:String,
        labelText:String,
        inputVModel:Object,
        searchKey:String,
        searchValueModel:Object,
      },
      data() {
        return {
          selected: {},
          optionsShown: false,
          searchFilter: '',
        }
      },
      created() {
        this.selected = {key: -1, value:this.placeholder}; 
        //("selected: ", this.selected);
        this.$emit('selected', this.selected.key);
      },
      computed: {
        filteredOptions() {
          const filtered = [];
          const regOption = new RegExp(this.searchFilter, 'ig');
          for (const option of this.options) {
            if (this.searchFilter != null && this.searchFilter.length < 1 || option.value.match(regOption)){
              if (filtered.length < this.maxItem) filtered.push(option);
            }
          }
          return filtered;
        }
      },
      unmounted(){
        //console.log("unmounting searchable dropdown");
      },
      methods: {
        selectOption(option) {
          //console.log("selected: " , option);
          this.selected = option;
          this.optionsShown = false;
          this.searchFilter = this.selected.value;
          this.$emit('selected', this.selected);
          this.$emit("UpdateForm", this.objectKey, this.selected.key);
          this.$emit("UpdateForm", this.searchKey, this.selected.value);
        },
        showOptions(){
          if (!this.disabled) {
            this.searchFilter = '';
            this.optionsShown = true;
          }
        },
        exit() {
          

          if (!this.selected.key) {
            this.selected = {};
            this.searchFilter = '';
          } else {
            this.searchFilter = this.selected.value;
          }
          this.$emit('selected', this.selected);
          this.$emit("UpdateForm", this.objectKey, this.selected.key);
          this.$emit("UpdateForm", this.searchKey, this.selected.value);
          this.optionsShown = false;
        },
        // Selecting when pressing Enter
        keyMonitor: function(event) {
          if (event.key === "Enter" && this.filteredOptions[0])
            this.selectOption(this.filteredOptions[0]);
        },
        HandleClickOutside(){
          if(this.optionsShown){
            //console.log("clicked outside");
            this.exit(); 
            this.$emit('blur');
          }
         
        },
        ClearInput(){
          //console.log("clearing input searchable dropdown");
          this.selected = {key: -1, value:this.placeholder}; 
          this.searchFilter = "";
        }
      },
      watch: {
        searchFilter() {
          //console.log("search filter changed");
          if (this.filteredOptions.length === 0) {
            this.selected = {};
          } else {
            this.selected = this.filteredOptions[0];
          }
          this.$emit('filter', this.searchFilter);
        },
        inputVModel(newVal,oldVal){
          oldVal;
          //console.log("new value: ", newVal, "old value: ", oldVal, "selected: ");
          this.selectOption({key: newVal, value:this.selected.value})
        },
        searchValueModel(newVal,oldVal){
          oldVal;
          //console.log("new value: ",newVal," old value: ", oldVal); 
          this.searchFilter = newVal; 
        }
      }
    };
  </script>
  
  
  <style lang="scss" scoped>
    .dropdown {
      position: relative;
      display: block;
      margin: auto;
      .dropdown-input {
        background: #fff;
        cursor: pointer;
        border: 1px solid lightgrey;
        border-radius: 3px;
        color: black;
        display: block;
        font-size: 16px;
        padding: 6px;
        min-width: 250px;
        width:100%;
        &:hover {
          background: #f8f8fa;
        }
      }
      .dropdown-input::placeholder{
        color:black;
      }
      .dropdown-content {
        position: absolute;
        background-color: #fff;
        min-width: 248px;
        width:100%;
        max-height: 220px;
        border: 1px solid lightgrey;
        box-shadow: 0px -8px 34px 0px rgba(0,0,0,0.05);
        overflow: auto;
        z-index: 1;
        text-align:left;
      }
        .dropdown-item {
          color: black;
          font-size: 16px;
          line-height: 1em;
          padding: 8px;
          text-decoration: none;
          display: block;
          cursor: pointer;
          &:hover {
            background-color: #e7ecf5;
          }
        }
      
      .dropdown:hover .dropdowncontent {
        display: block;
      }

      .arrow{
        border:solid black;
        border-width: 0px 2px 2px 0px;
        display:inline-block;
        padding:2.5px;
        position:absolute;
        top:42px;
        right:6px;
      }
      .down{
        transform:rotate(45deg);
      }
    }
  </style>